// Cycles through `phrases`, typing/holding/deleting each in turn.
// Resets to the start whenever the phrase SET changes (e.g. switching
// industry tabs), keyed on the phrases' joined content.
export function useTypewriter(phrases, options = {}) {
  const { useState, useEffect, useRef } = React;
  const { typeSpeed = 36, holdMs = 1600, deleteSpeed = 22 } = options;
  const [text, setText] = useState("");
  const [i, setI] = useState(0);
  const [phase, setPhase] = useState("typing"); // typing | holding | deleting
  const phrasesKey = phrases.join("|");
  const prevKey = useRef(phrasesKey);

  useEffect(() => {
    if (prevKey.current !== phrasesKey) {
      prevKey.current = phrasesKey;
      setText("");
      setI(0);
      setPhase("typing");
    }
  }, [phrasesKey]);

  useEffect(() => {
    const phrase = phrases[i % phrases.length];
    let t;
    if (phase === "typing") {
      if (text.length < phrase.length) {
        t = setTimeout(() => setText(phrase.slice(0, text.length + 1)), typeSpeed);
      } else {
        t = setTimeout(() => setPhase("holding"), holdMs);
      }
    } else if (phase === "holding") {
      t = setTimeout(() => setPhase("deleting"), holdMs);
    } else if (phase === "deleting") {
      if (text.length > 0) {
        t = setTimeout(() => setText(phrase.slice(0, text.length - 1)), deleteSpeed);
      } else {
        setI((x) => x + 1);
        setPhase("typing");
      }
    }
    return () => clearTimeout(t);
  }, [text, phase, i, phrasesKey, typeSpeed, holdMs, deleteSpeed]);

  return text;
}
